<section id="dashboard-admin-employee">
    <div class="card employee-container">
        <div class="card-header">
            <div class="card-title font-weight-bold">Empleado</div>
            <p class="grey mb-0"><span>Año Actual</span></p>
        </div>
        <div *ngIf="dashboardEmployee" class="card-body py-0">
            <div class="row">
                <div class="col-12 employee-col">
                    <div class="card employee-card">
                        <div class="card-body d-flex">
                            <div class="avatar-div d-flex flex-column flex-md-row align-items-center">
                                <div class="avatar-container">
                                    <div class="avatar avatar-shadow mr-0 mr-md-3 ml-0"
                                        style="width: 62px; height: 62px;">
                                        <img *ngIf="imgPreview; else defaultImg" [src]="imgPreview" alt="profile-img"
                                            class="avatar-content w-100 h-100">
                                    </div>
                                    <ng-template #defaultImg>
                                        <div class="avatar-content"
                                            style="font-size: 15px; line-height: 84px; margin: auto;">
                                            {{ (dashboardEmployee.employee.last_name | shortName) | slice:0:3 }}
                                        </div>
                                    </ng-template>
                                </div>
                                <div
                                    class="d-flex align-items-center justify-content-center justify-content-md-start mt-2 mt-md-0 w-100">
                                    <span class="font-weight-bold lead">
                                        {{ dashboardEmployee.employee.name}} {{ dashboardEmployee.employee.last_name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="calendar-stats-container">
                                <div class="card">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex flex-wrap">
                                                <div class="media-body text-left">
                                                    <div class="d-flex align-items-center">
                                                        <h4 class="mb-1" [ngClass]="calendarStatsClass"
                                                            [countUp]="calendarStats.totalHolidays">
                                                        </h4>
                                                        <span class="ml-2" style="font-size: .6rem !important;">
                                                            (<strong
                                                                [countUp]="calendarStats.totalHolidaysPrevYear"></strong>
                                                            Año Anterior)
                                                        </span>
                                                    </div>
                                                    <span>Vacaciones</span>
                                                </div>
                                                <div class="media-right align-self-center">
                                                    <i class="ft-image font-large-1 float-right"
                                                        [ngClass]="calendarStatsClass"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex flex-wrap">
                                                <div class="media-body text-left">
                                                    <h4 class="mb-1" [ngClass]="calendarStatsClass"
                                                        [countUp]="calendarStats.totalPersonalMatters">
                                                    </h4>
                                                    <span>Asuntos Propios</span>
                                                </div>
                                                <div class="media-right align-self-center">
                                                    <i class="icon-notebook font-large-1 float-right"
                                                        [ngClass]="calendarStatsClass"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex flex-wrap">
                                                <div class="media-body text-left">
                                                    <h4 class="mb-1" [ngClass]="calendarStatsClass"
                                                        [countUp]="calendarStats.totalSickLeave">
                                                    </h4>
                                                    <span>Bajas</span>
                                                </div>
                                                <div class="media-right align-self-center">
                                                    <i class="ft-home font-large-1 float-right"
                                                        [ngClass]="calendarStatsClass"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex flex-wrap">
                                                <div class="media-body text-left">
                                                    <h4 class="mb-1" [ngClass]="calendarStatsClass"
                                                        [countUp]="calendarStats.totalPaidLeave">
                                                    </h4>
                                                    <span>Permisos Retribuidos</span>
                                                </div>
                                                <div class="media-right align-self-center">
                                                    <i class="ft-dollar-sign font-large-1 float-right"
                                                        [ngClass]="calendarStatsClass"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex flex-wrap">
                                                <div class="media-body text-left">
                                                    <h4 class="mb-1" [ngClass]="calendarStatsClass"
                                                        [countUp]="calendarStats.totalRemoteWork">
                                                    </h4>
                                                    <span>Teletrabajo</span>
                                                </div>
                                                <div class="media-right align-self-center">
                                                    <i class="ft-monitor font-large-1 float-right"
                                                        [ngClass]="calendarStatsClass"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-load-screen *ngIf="isLoading" loadingText="Cargando estadísticas del empleado..."></app-load-screen>
    </div>
</section>